<template lang="html">
  <footer class="footer">
    <ul>
      <li class="footer__smLink hover" v-if="sm.facebookUrl"><a :href="sm.facebookUrl"><img src="../assets/facebook.svg" alt="facebook"/></a></li>
      <li class="footer__smLink hover" v-if="sm.instagramUrl"><a :href="sm.instagramUrl"><img src="../assets/instagram.svg" alt="instagram"/></a></li>
      <li class="footer__smLink hover" v-if="sm.vimeoUrl"><a :href="sm.vimeoUrl"><img src="../assets/vimeo.svg" alt="vimeo"/></a></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    sm() {
      return this.$store.state.config;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/config.scss";
.footer {
  text-align: right;
  padding: 20px;
  position: absolute;
  bottom: 40px;
  right: 20px;
  // z-index: 1;
  &.footerInHome {
    bottom: 64px;
    padding: 0;
    right: 8%;
  }
  &__smLink {
    display: inline-block;
    font-family: CamptonBold;
    font-size: 14px;
    transition: color 0.2s ease-in;
    padding: 4px;
    a {
      color: var(--Neu01);
    }
  }
  @include mq(0, 768px) {
    position: relative;
    bottom: auto;
    right: auto;
    background-color: var(--Neu10);
    &.footerInHome {
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue